import { render } from "./EventScreen.vue?vue&type=template&id=753cef12&ts=true&lang=pug"
import script from "./EventScreen.vue?vue&type=script&lang=ts"
export * from "./EventScreen.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__